var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'theme-dark': _vm.isDarkMode },attrs:{"id":"app"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }